<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="! newsList.length">
        <p>No news data found.</p>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0" v-else>
        <h1>{{geth1}}</h1>
    

        <div class="artical-post">
            <div class="image-box">
            <img width="640" height="360" :src="newsList[0].image_url.resizeImage(640)" :alt="newsList[0].heading" loading="lazy" />
            </div>
            <div class="sub-head-line" v-if="newsList[0].match">
                <span class="badge">{{ newsList[0].category_id == 22 ? 'Match Preview' : (newsList[0].category_id == 23 ? 'Match Report':'') }}</span>
                <router-link :to="{name: 'matchDetail.Scorecard', params: {match: newsList[0].match.slug}}">
                    <span class="match-info">
                        <span>{{ newsList[0].match.team1.name }}</span> vs <span>{{ newsList[0].match.team2.name }}</span>
                    </span>
                </router-link>
            </div>
            <h1>
                <router-link :to="{name: 'newsArticle', params: { news: newsList[0].slug, ...(newsList[0].match) && {match: newsList[0].match.slug} } }">
                    {{ newsList[0].heading }}
            </router-link>
        </h1>
        <p>{{ newsList[0].subheading }}</p>
        <time class="time" :datetime="newsList[0].created_at | formatDate('YYYY-MM-DD')">
              {{ newsList[0].created_at | timeElaped }}
    </time>
    <div class="btn-wrap">
        <router-link :to="{name: 'newsArticle', params: { news: newsList[0].slug, ...(newsList[0].match) && {match: newsList[0].match.slug} } }" class="btn btn-dark">
            Read More
    </router-link>
    <router-link v-if="newsList[0].match.slug && newsList[0].highlights.length" class="btn btn-outline-light" 
                 :to="{ name: 'matchDetail.Videos', params: { match: newsList[0].match.slug }}" >Watch Highlights
</router-link>
</div>
</div>
<div class="content-box" v-if="newsList.length > 1">
    <strong class="h2 text-uppercase">Latest news</strong>
    <div class="post-holder">
        <div class="post news" v-for="(news,index) in newsList.slice(1)" :key="news.id">
            <router-link :to="{name: 'newsArticle', params: { news: news.slug, ...(news.match.slug) && {match: news.match.slug}} }">
                <div class="img-holder">
                    <img width="300" height="195" loading="lazy" :src="news.image_url.replace('.jpg', '-big.jpg').resizeImage(300)" :alt="news.heading" />
                </div>
                <div class="descrip">
                    <div class="sub-head-line" v-if="news.match">
                        <span class="badge">{{ news.category_id == 22 ? 'Match Preview' : (news.category_id == 23 ? 'Match Report':'') }}</span>
                        <router-link :to="{name: 'matchDetail.Scorecard', params: {match: news.match.slug}}">
                            <span class="match-info">
                                <span>{{ news.match.team1.name }}</span> vs <span>{{ news.match.team2.name }}</span>
                            </span>
                        </router-link>
                    </div>
                    <h2>{{ news.heading }}</h2>
                    <p>{{ news.subheading }}</p>
                    <time class="time" :datetime="news.created_at | formatDate('YYYY-MM-DD')">
                          {{ news.created_at | timeElaped }}
                </time>
            </div>
        </router-link>

        <!-------------------------------------------Ads---------------------------------------->
        <div style="display:flex;justify-content: center;width: 100%;margin-top: 20px;" class="d-md-none" v-if="index == 0">

            <div class="ft_async_tag" style="width: 300px;">
            
                <iframe :src="'https://servedby.flashtalking.com/imp/1/162408;7132164;201;jsiframe;PlanetCricket;PlanetCricket300x250/?ft_custom=&imageType=gif&ftDestID=35488582&ft_width=300&ft_height=250&click=&ftOBA=1&ftExpTrack=&gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&cachebuster='+Date.now()" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" topmargin="0" leftmargin="0" allowtransparency="true" width="300" height="250">
    
                    <a href="https://servedby.flashtalking.com/click/1/162408;7132164;0;209;0/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&ft_width=300&ft_height=250&url=35488582" target="_blank">
                    
                    <img border="0" src="https://servedby.flashtalking.com/imp/1/162408;7132164;205;gif;PlanetCricket;PlanetCricket300x250/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}"></a>
                    
                    </iframe>
            </div>
            </div>
        <!-------------------------------------------Ads End---------------------------------------->
    </div>
</div>
<div class="text-center">
    <a type="button" class="btn btn-dark" v-if="nextPageUrl" @click="loadMore()" href="javascript:;">Load more</a>
</div>
</div>
<!--      footer text-->
<div class="note-text text-center py-10">
    <p>
      Planet Cricket Serves You with All the Updates and Latest Cricket News. Exclusive Cricket Content with Match Reports, Predictions, Results, Rumours and Latest Cricket News Expert Analysis Brought to You by Planet Cricket's News Experts.
    </p>
</div>
</div>
</template>

<script>
    export default {
        name: 'newsList',
        data() {
            return {
                newsList: [],
                nextPageUrl: '',
                id: '',
                h1:[],
                removed:[]
            }
        },
        computed: {

            geth1() {
                if(this.$route.name == 'newsList')
                {
                    return ('Latest Cricket News')
                }
                this.h1 = (this.$route.params.tournament.split('-'))
                this.removed = (this.h1).splice(-1)
                for (let i = 0; i < this.h1.length; i++) {
                    this.h1[i] = this.h1[i][0].toUpperCase() + this.h1[i].substr(1);
                }
                return   this.h1.join(' ')
            },
        },
        jsonld() {
            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

            let events = [];
            this.newsList.forEach((article) => {
                events.push(
                        {
                            '@type': 'NewsArticle',
                            mainEntityOfPage: {
                                '@type': 'WebPage',
                                '@id': "https://planetcricket.com" + this.$route.path
                            },
                            headline: article.heading,
                            description: article.subheading,
                            image: article.image_url,
                            author: {
                                '@type': 'Person',
                                name: article.author,
                                "url" : process.env.BASE_URL
                            },
                            publisher: {
                                '@type': 'Organization',
                                name: 'Planet Cricket',
                                logo: {
                                    '@type': 'ImageObject',
                                    url: process.env.BASE_URL + 'public/images/logo1280x720.png'
                                }
                            },
                            datePublished: article.created_at,
                            dateModified: article.updated_at
                        }
                )
            });
            return {
                "@context": "http://schema.org",
                "@graph": events
            };
        },
        watch: {
            '$route.params.tournament'() {
                if(isBrowser)
                    this.main()
            },

        },
        metaInfo() {
          //  let title = "Latest Cricket News - PlanetCricket.com";
            let title = this.geth1 + ", Highlights, Report";
            let description = "Keep up to date with all the latest cricket news updates, catch all the player updates, match highlights of your favorite teams, and leagues - PlanetCricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },

        mounted() {
            this.main();
        },
        methods: {
            main() {
                let params = {}
                if(this.$route.params.tournament){
                    this.id = this.$route.params.tournament.split('-').slice(-1)[0]
                     params = {tournament:this.id}
                }
                return this.$axios.get(this.$NEWS_LIST_API,{params:params})
                        .then(response => {
                            this.is_data_ready = true
                            this.newsList = response.data.result.news || []
                            this.nextPageUrl = response.data.result.nextPageUrl
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            loadMore() {
                this.$axios.get(this.nextPageUrl)
                        .then(response => {
                            this.newsList = this.newsList.concat(response.data.result.news)
                            this.nextPageUrl = response.data.result.nextPageUrl
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>

